import { useState } from 'react'

const alphabet = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'

/**
 * Generate a persistent randomly-generated identifier.
 *
 * Use this hook to prevent the need for developers to have to come up
 * with an identifier to be able to use your component, where a random ID
 * would suffice.
 *
 * @param {string} providedId A provided identifier. Very Optional.
 * @returns {string} Either the providedId or a randomly-generated one.
 */
const useRandomId = (providedId?: string): string => {
  const [id] = useState(
    providedId ||
      // Always start with an alphabetical character, because starting with a number causes Sentry errors in browsers
      alphabet[Math.floor(Math.random() * alphabet.length)] +
        Math.random()
          .toString(36) // base-36 means generate digits from 0-9 and a-z
          .substr(2) // get rid of the "0." at the beginning of the number
  )
  return id
}

export default useRandomId
